import MassTextOutreach from './MassTextOutreach';

export default MassTextOutreach;
